module.exports = __webpack_public_path__ + "img/visitor.a7760b62.png";